import React from "react"
import Navbar from "./Navbar"
import TopMenu from "./topMenu"

const Header=()=>{
    return(
        <header className="bg-[#f4f6f4]">
            <TopMenu/>
            <Navbar/>
        </header>
    )
}

export default Header